export default __webpack_public_path__ + "static/media/kubernetes.3ade6bfa4b917a8227680e3f34cf6957.svg";